module.exports = __webpack_public_path__ + "static/img/nt5.2475c0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/nt5.jpg
// module id = c6ix
// module chunks = 0